import dragDrop from 'drag-drop';

/**
 * Event listener for handling clicks on the select element.
 */
const loseSelectFocusAfterPickUp = () => {
    // Find the select element with the class "field-group-select" within the form
    const selects = document.querySelectorAll('.field-group__select');

    selects.forEach((select) => {
        /**
         * Event listener for handling clicks on the select element.
         */
        // select.addEventListener('click', () => {
        //     if(select.classList.contains('active')){
        //         select.classList.remove('active');
        //         select.blur();
        //     }else{
        //         select.classList.add('active');
        //     }
        // });
        /**
         * Event listener for handling changes in the select element.
         *
         * @param {Event} event - The change event.
         */
        select.addEventListener('change', () => {
            select.blur(); // Remove focus when the value is changed
            select.classList.remove('active');
        });
    });

    // document.addEventListener('click', (event) => {
    //     selects.forEach(select => {
    //         const isSelectClicked = select.contains(event.target);
    //         console.log(event.target);
    //         if (!isSelectClicked) {
    //             select.classList.remove('active');
    //         }
    //     });
    // });
};

// Initialize the form interactions
const initForm = () => {
    // Call a function to handle select interactions
    loseSelectFocusAfterPickUp();
    fileGroup();
};

/**
 * Handles file selection and drag-and-drop for file groups.
 */
const fileGroup = () => {
    // Get all file group elements
    const fileGroups = document.querySelectorAll('[data-file-group]');

    // Check if there are any file groups
    if (fileGroups.length) {
        // Iterate through each file group
        fileGroups.forEach((group) => {
            // Get the file input element
            const input = group.querySelector('input[type="file"]');

            // Check if there is a file input element
            if (input) {
                // Add an event listener for the change event of the file input
                input.addEventListener('change', (event) => {
                    // Check if a file has been selected
                    if (input.files[0]) {
                        // Update the title of the file group to show the selected file name
                        group.querySelector(
                            '[data-file-group-title]'
                        ).textContent = input.files[0].name;
                    } else {
                        group.querySelector(
                            '[data-file-group-title]'
                        ).textContent = 'no file chosen';
                    }
                    console.log(input.files);
                });

                // Add drag-and-drop functionality to the file group
                dragDrop(group, (files) => {
                    // Create a new DataTransfer object
                    const dataTransfer = new DataTransfer();

                    // Add the dropped file to the DataTransfer object
                    dataTransfer.items.add(files[0]);

                    // Update the file input's files property with the dropped file
                    input.files = dataTransfer.files;

                    // Create a change event and dispatch it on the file input
                    const changeEvent = new Event('change', {
                        bubbles: true,
                        cancelable: true,
                        files,
                    });
                    input.dispatchEvent(changeEvent);
                });
            }
        });
    }
};

// Export the "initForm" function for use in other modules
export {initForm};

export function initTrialFormHandler() {

    const form = document.getElementById("trial-version-form");

    if (!form) {
        console.error("Form not found!");
        return;
    }

    form.addEventListener("submit", async (event) => {

        event.preventDefault();
        const submitButton = form.querySelector('[type="submit"]');
        submitButton.disabled = true;
        const formData = new FormData(form);
        const params = new URLSearchParams();

        formData.forEach((value, key) => {
            if (value) {
                params.append(key, value);
            }
        });

        //const apiUrl = `https://bettystaging.accountedge.com/TrialVersion/TrialVersion?${params.toString()}`;
        const apiUrl = `https://betty.acclivitysoftware.com/TrialVersion/TrialVersion?${params.toString()}`;

        try {
            const response = await fetch(apiUrl);
            const text = await response.text();

            let result;

            try {
                result = JSON.parse(text);
            } catch (jsonError) {
                alert("Error: The server returned an invalid response.");
                return;
            }

            if (result.status === "ok" && result.url) {

                console.log(result.url);

                document.getElementById("redirect_url").value = result.url;

                form.action = result.url;
                form.submit();
                setTimeout(() => {
                    window.history.replaceState({}, document.title, result.url.split("?")[0]);
                }, 500);
            } else {
                alert("Error: The server did not return the correct URL.");
            }
        } catch (error) {
            console.error("Fetch error:", error);
        } finally {
            submitButton.disabled = false;
        }
    });
}
